(<template>
  <div class="verification-page">
    <verification v-if="isVerificationView"
                  @verify="verifyUser" />
    <shared-account-verification v-else-if="isShared" />
    <failed-verification v-else
                         :failed-reason="currentView"
                         @verify="verifyUser" />
  </div>
</template>)

<script>
  import {mapGetters} from 'vuex';
  import constants from '@/modules/constants';
  import Verification from '@/components/shared_components/bankVerification/Verification';
  import SharedAccountVerification from '@/components/shared_components/bankVerification/SharedAccountVerification';
  import FailedVerification from '@/components/shared_components/bankVerification/FailedVerification';

  export default {
    components: {
      verification: Verification,
      'failed-verification': FailedVerification,
      'shared-account-verification': SharedAccountVerification,
    },
    computed: {
      ...mapGetters('UserInfoStore', [
        'userIsInterpreter',
        'isShared'
      ]),
      currentView() { return this.$route.query.view; },
      isVerificationView() { return (this.currentView === 'verification' || this.currentView === 'signIn') && (!this.isShared); },
    },
    methods: {
      verifyUser() {
        const {subtaskId, orderId, redirectUrl} = this.$route.query;
        const baseUrl = constants.SECURE_PATH.replace(/\/+$/, '');
        const url = `${baseUrl}/criipto-login?redirectUrl=https://${this.$getString('rootPath', process.env.NODE_ENV)}${redirectUrl}&subtaskId=${subtaskId || ''}&orderId=${orderId || ''}`;
        if (this.userIsInterpreter) localStorage.setItem('subtaskId', subtaskId);
        window.location.href = url;
      }
    }
  };
</script>

<style src="@/assets/css/bank_verification.css"></style>
